import { useMemo } from 'react'
import { ALL_CATEGORIES, POSE_COUNT, POSES } from '../poses/library'
import { useAppStore } from '../store'

export function PoseList() {
  const poseId = useAppStore((s) => s.poseId)
  const search = useAppStore((s) => s.search)
  const categoryFilter = useAppStore((s) => s.categoryFilter)
  const setPoseId = useAppStore((s) => s.setPoseId)
  const setSearch = useAppStore((s) => s.setSearch)
  const setCategoryFilter = useAppStore((s) => s.setCategoryFilter)
  const locked = useAppStore((s) => s.controlsLocked)

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase()
    return POSES.filter((p) => {
      if (categoryFilter !== 'all' && !p.categories.includes(categoryFilter as never)) return false
      if (!q) return true
      return (
        p.english.toLowerCase().includes(q) ||
        p.sanskrit.toLowerCase().includes(q) ||
        p.categories.some((c) => c.toLowerCase().includes(q))
      )
    })
  }, [search, categoryFilter])

  return (
    <aside className="panel pose-panel">
      <div className="panel-header">
        <h2>Poses</h2>
        <span className="badge">{POSE_COUNT} total</span>
      </div>
      <input
        className="search"
        placeholder="Search English or Sanskrit…"
        value={search}
        disabled={locked}
        onChange={(e) => setSearch(e.target.value)}
      />
      <select
        className="select"
        value={categoryFilter}
        disabled={locked}
        onChange={(e) => setCategoryFilter(e.target.value)}
      >
        <option value="all">All categories</option>
        {ALL_CATEGORIES.map((c) => (
          <option key={c} value={c}>{c}</option>
        ))}
      </select>
      <p className="muted small">Showing {filtered.length} of {POSE_COUNT}</p>
      <ul className="pose-list">
        {filtered.map((p) => (
          <li key={p.id}>
            <button
              type="button"
              className={p.id === poseId ? 'pose-item active' : 'pose-item'}
              disabled={locked}
              onClick={() => setPoseId(p.id)}
            >
              <span className="pose-en">{p.english}</span>
              <span className="pose-sa">{p.sanskrit}</span>
              <span className="pose-meta">{p.difficulty} · {p.categories[0]}</span>
            </button>
          </li>
        ))}
      </ul>
    </aside>
  )
}
